customElements.get("load-more") || customElements.define("load-more", class extends HTMLElement {
  constructor() {
    super(), this.button = this.querySelector("a"), this.buttonText = this.button?.textContent, 
    this.section = this.dataset.section || "", this.selectors = [ "[data-grid]" ], this.per_page = this.dataset.perPage || null, 
    window.addEventListener("popstate", this.scrollUp.bind(this));
  }
  connectedCallback() {
    this.button?.addEventListener("click", this.loadMore.bind(this));
  }
  loadMore(t) {
    t.preventDefault(), t.stopPropagation(), window.dataLayer = window.dataLayer || [], 
    window.dataLayer.push({
      event: "select_content",
      content_type: "navigation",
      content_id: "plp-load-more",
      link_text: this.buttonText ? this.buttonText.trim() : null,
      link_url: t.target.href,
      page_section: "plp",
      page_type: document.body.getAttribute("data-template") || null
    }), document.dispatchEvent(new CustomEvent("spinner:show", {
      detail: {
        source: "load-more"
      }
    })), this.classList.add("opacity-50", "cursor-wait"), window.strings.loading && (this.button.textContent = window.strings.loading);
    const e = t.target.dataset.mode?.includes("prev") ? "afterbegin" : "beforeend", n = document.querySelector(`#shopify-section-${this.section}`) || document, o = new URL(t.target.href), s = new URLSearchParams(o.search);
    s.set("section_id", this.section), fetch(`${o.pathname}?${s.toString()}`).then(t => t.text()).then(o => {
      const r = (new DOMParser).parseFromString(o, "text/html");
      [ `[data-load-${t.target.dataset.mode || "next"}]`, ...this.selectors ].forEach(o => {
        const i = n.querySelector(o);
        if (i) {
          const t = r.querySelector(o);
          t ? o.toLowerCase().includes("grid") ? i.insertAdjacentHTML(e, t.innerHTML) : i.innerHTML = t.innerHTML : i.parentNode.removeChild(i);
        }
        history.pushState(Object.fromEntries(s), "", t.target.href), this.button.textContent = this.buttonText;
      });
    }).catch(e => {
      console.warn(e), location.href = t.target.href;
    }).finally(() => {
      document.dispatchEvent(new CustomEvent("spinner:hide", {
        detail: {
          source: "load-more"
        }
      })), this.classList.remove("opacity-50", "cursor-wait");
    });
  }
  scrollUp() {
    if (!this.selectors.length || !this.per_page) return;
    const t = new URLSearchParams(window.location.search), e = parseInt(t.get("page")) || 1, n = document.querySelector(this.selectors[0]).children[(e - 1) * this.per_page] || !1;
    n && n.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }
});